export default __webpack_public_path__ + "static/media/Philadelphia_brunch_25_pdf_recipe_cards_ROI.ab585226.pdf";